import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';
import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

const useDeleteShipCost = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const deleteShipCostMutation = useMutation(
    async (id) => {
      const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/shipping/delete/inter/state/cost/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('shippingCost');
      },
    }
  );

  const deleteShipCost = async (id) => {
    try {
      await deleteShipCostMutation.mutateAsync(id);
    } catch (error) {
      console.error('Error deleting shipping cost:', error);
    }
  };

  return {
    deleteShipCost,
    isDeleting: deleteShipCostMutation.isLoading,
  };
};

export default useDeleteShipCost;